import React, { SVGProps } from 'react';

const SvgOdometer = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			height='1em'
			width='1em'
			fill='currentColor'
			className='svg-icon'
			{...props}>
			<mask
				id='mask0_1999_22220'
				style={{ maskType: 'alpha' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='24'
				height='24'>
				<rect width='24' height='24' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask0_1999_22220)'>
				<path
					d='M9 21C7.9 21 6.95833 20.6083 6.175 19.825C5.39167 19.0417 5 18.1 5 17V8.825C4.41667 8.60833 3.93733 8.24567 3.562 7.737C3.18733 7.229 3 6.65 3 6C3 5.16667 3.29167 4.45833 3.875 3.875C4.45833 3.29167 5.16667 3 6 3C6.83333 3 7.54167 3.29167 8.125 3.875C8.70833 4.45833 9 5.16667 9 6C9 6.65 8.81267 7.229 8.438 7.737C8.06267 8.24567 7.58333 8.60833 7 8.825V17C7 17.55 7.196 18.021 7.588 18.413C7.97933 18.8043 8.45 19 9 19C9.55 19 10.021 18.8043 10.413 18.413C10.8043 18.021 11 17.55 11 17V7C11 5.9 11.3917 4.95833 12.175 4.175C12.9583 3.39167 13.9 3 15 3C16.1 3 17.0417 3.39167 17.825 4.175C18.6083 4.95833 19 5.9 19 7V15.175C19.5833 15.3917 20.0627 15.754 20.438 16.262C20.8127 16.7707 21 17.35 21 18C21 18.8333 20.7083 19.5417 20.125 20.125C19.5417 20.7083 18.8333 21 18 21C17.1667 21 16.4583 20.7083 15.875 20.125C15.2917 19.5417 15 18.8333 15 18C15 17.35 15.1873 16.7667 15.562 16.25C15.9373 15.7333 16.4167 15.375 17 15.175V7C17 6.45 16.8043 5.97933 16.413 5.588C16.021 5.196 15.55 5 15 5C14.45 5 13.9793 5.196 13.588 5.588C13.196 5.97933 13 6.45 13 7V17C13 18.1 12.6083 19.0417 11.825 19.825C11.0417 20.6083 10.1 21 9 21ZM6 7C6.28333 7 6.521 6.90433 6.713 6.713C6.90433 6.521 7 6.28333 7 6C7 5.71667 6.90433 5.479 6.713 5.287C6.521 5.09567 6.28333 5 6 5C5.71667 5 5.479 5.09567 5.287 5.287C5.09567 5.479 5 5.71667 5 6C5 6.28333 5.09567 6.521 5.287 6.713C5.479 6.90433 5.71667 7 6 7ZM18 19C18.2833 19 18.5207 18.904 18.712 18.712C18.904 18.5207 19 18.2833 19 18C19 17.7167 18.904 17.4793 18.712 17.288C18.5207 17.096 18.2833 17 18 17C17.7167 17 17.4793 17.096 17.288 17.288C17.096 17.4793 17 17.7167 17 18C17 18.2833 17.096 18.5207 17.288 18.712C17.4793 18.904 17.7167 19 18 19Z'
					fill='#F00D69'
				/>
			</g>
		</svg>
	);
};

export default SvgOdometer;
